import { Badge, Label, Text, makeStyles, tokens } from "@fluentui/react-components";
import { ContractBranch } from "../../../../models/Entities/Contracts/ContractBranch";
import { Protocol } from "../../../../models/Entities/Protocols/Protocol";
import { ErrorType } from "../../../../models/HttpError";

// styles
import './BranchList.Styles.css';
import { ConfirmationButtonComponent } from "../../../../commons/component/ConfirmationButton/ConfirmationButtonComponent";

////i18Next
import { useTranslation, Trans } from 'react-i18next';

const useStyles = makeStyles({
    branchIndex: {
        fontSize: tokens.fontSizeBase200
    },
    branchName: {
        fontSize: tokens.fontSizeBase300
    },
    protocolBadge: {
        marginTop: "4px",
        padding: "10px 15px",
        fontSize: tokens.fontSizeBase200
    }
});

export interface IProps {
    Branch: ContractBranch;
    index: number;
    onEdit?: (branch: ContractBranch) => void;
    onDelete?: (branch: ContractBranch) => void;
    deleteProcess: boolean;
    deleteSuccess: boolean | undefined;
    deleteError: boolean;
    Error: ErrorType | undefined;
    Protocols?: Protocol[];
}

export const BranchItemComponent = (props: IProps) => {
    //useTranslation()
    const [t] = useTranslation();
    const styles = useStyles();

    const relatedProtocol = props.Protocols?.find(
        (protocol: Protocol) => protocol.id === props.Branch.protocolIdRelatedToBranch
    );

    return (
        <>
            <div className="BranchListItem" onClick={(event) => { event.stopPropagation(); props.onEdit && props.onEdit(props.Branch); }}>
                <div className="BranchIndex">
                    <Text className={styles.branchIndex}>{t('branchItem.textBranch')} {props.index + 1}</Text>
                </div>
                <div className="BranchLsitItemContent">
                    <Label className="BranchName">{props.Branch.branchName}</Label>
                    {props.Branch.branchDescription && <div>
                        <Text>{props.Branch.branchDescription}</Text>
                    </div>}
                    {props.Branch.protocolIdRelatedToBranch && (
                        <div className="BranchProtocol">
                            <Badge appearance="tint" color="brand" size="small" className={styles.protocolBadge}>
                                {relatedProtocol?.title ?? t('branchItem.protocolFallback', 'Protocolo') + ` #${props.Branch.protocolIdRelatedToBranch}`}
                            </Badge>
                        </div>
                    )}
                </div>
                <div className="danger">
                <ConfirmationButtonComponent 
                ButtonId={"deletebranch" + props.Branch.id} 
                ButtonIconName={"Delete"} 
                ButtonText={""} 
                ButtonCssClass={""} 
                ConfirmationButtonText={t('branchItem.confirmationButton.deleteButton')} 
                ConfirmationButtonCssClass={"deleteButton"} 
                CancelButtonText={t('branchItem.confirmationButton.cancelButton')} 
                CancelButtonCssClass={""} 
                Title={t('branchItem.confirmationButton.branchDeleteConfirm')} 
                Description={""} 
                ElementTextHeader={t('branchItem.confirmationButton.branchDelete')+ props.Branch.branchName} 
                ElementTextInformation={t('branchItem.confirmationButton.textInformation')} 
                onConfirmation={() =>
                    props.onDelete && props.onDelete(props.Branch)
                  }
                  onCancel={() => undefined}
                  isOperationExecuting={
                    props.deleteProcess
                  }
                  isOperationExecutedWithError={
                    props.deleteError
                  }
                  OperationError={props.Error
                  }
                />
                </div>
            </div>
        </>
    );
}